<svelte:options customElement="hb-matrix-video" />

<script lang="ts">
  import pkg from "../../../package.json";
  import debounce from "debounce";

  import parseStyle from "style-to-object";
  import {
    addComponent,
    getChildStyleToPass,
    LanguageTranslator,
  } from "wc-js-utils";
  import type { Component } from "./types/webcomponent.type";
  import { styleSetup as playerLiveStyleSetup } from "../player-live/extra/docs";
  import { onMount } from "svelte";

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }

  const component: HTMLElement = $host();
  let {
    id = "",
    // style = "",
    items,
  }: Component = $props();

  let parsedStyle: { [x: string]: string } = $state({});
  let playerLiveStyleToSet: string = "";

  let h: number = $state(0);
  let w: number = $state(0);
  let o = $derived(() => {
    return w > h ? "landscape" : "portrait";
  });

  let rows: number = $state(0);
  let cols: number = $state(0);
  let videoSelectedId: string | undefined = $state(undefined);

  let drawItems: { row: number; items: Component["items"] }[] = $state([]);

  function setRowsAndCols() {
    if (w && h) {
      // Calculate the optimal number of rows and columns for the given items
      // (only works for 1 or 2 items at the moment
      const videoAspectRatio = 16 / 9;
      const containerAspectRatio = w / h;
      let optimalRows: number = 0;
      let optimalCols: number = 0;
      if (items.length === 1) {
        optimalRows = 1;
        optimalCols = 1;
      } else if (w < 450) {
        optimalCols = 1;
        optimalRows = items.length;
      } else if (items.length === 2) {
        if (containerAspectRatio > videoAspectRatio) {
          // Window is wider than the video aspect ratio (landscape orientation)
          optimalRows = 1;
          optimalCols = 2;
        } else {
          // Window is taller than the video aspect ratio (portrait orientation)
          optimalRows = 2;
          optimalCols = 1;
        }
      } else {
        // Calculate for both landscape and portrait orientations
        if (containerAspectRatio > videoAspectRatio) {
          // Window is wider than the video aspect ratio (landscape orientation)
          let minDiff = Infinity;

          for (let rows = 1; rows <= items.length; rows++) {
            const cols = Math.ceil(items.length / rows);
            const totalWidth = (h / rows) * videoAspectRatio * cols;

            if (totalWidth <= w) {
              const diff = w - totalWidth;
              if (diff < minDiff) {
                minDiff = diff;
                optimalRows = rows;
                optimalCols = cols;
              }
            }
          }
        } else {
          // Window is taller than the video aspect ratio (portrait orientation)
          let minDiff = Infinity;

          for (let cols = 1; cols <= items.length; cols++) {
            const rows = Math.ceil(items.length / cols);
            const totalHeight = (w / cols / videoAspectRatio) * rows;

            if (totalHeight <= h) {
              const diff = h - totalHeight;
              if (diff < minDiff) {
                minDiff = diff;
                optimalCols = cols;
                optimalRows = rows;
              }
            }
          }
        }
      }
      rows = optimalRows;
      cols = optimalCols;
      if (rows && cols) {
        const newDrawItems: { row: number; items: Component["items"] }[] = [];
        for (let i = 0; i < rows; i++) {
          for (let j = 0; j < cols; j++) {
            const item = items[i * cols + j];
            if (item) {
              if (!newDrawItems[i]) {
                newDrawItems[i] = { row: i, items: [] };
              }
              newDrawItems[i].items[j] = item;
            }
          }
        }
        drawItems = newDrawItems;
        console.log(drawItems, rows, cols, "drawItems");
      }
    }
  }
  function setSize() {
    if (window.innerWidth && window.innerHeight && component?.shadowRoot) {
      const shadowRoot: ShadowRoot = component.shadowRoot;
      const htmlContainer = shadowRoot.getElementById("matrix");

      if (htmlContainer?.style) {
        h = window.innerHeight - htmlContainer.offsetTop;
        w = Number(htmlContainer.clientWidth);

        htmlContainer.style.height = h + "px";
        console.log(`setSize w:${w} h:${h}`);
        setRowsAndCols();
      }
    }

    //
  }

  $effect(() => {
    // if (style) {
    //   parsedStyle = parseStyle(style) as any;
    //   playerLiveStyleToSet = getChildStyleToPass(
    //     parsedStyle,
    //     playerLiveStyleSetup?.vars
    //   );
    // }

    // json
    if (typeof items === "string") {
      try {
        items = JSON.parse(items);
        setRowsAndCols();
      } catch (err) {
        console.error("error parsing items", err);
      }
    }
  });
  addComponent({
    repoName: "@htmlbricks/hb-player-live",
    version: pkg.version,
  });

  onMount(() => {
    setSize();
  });

  function hoverItem(id?: string) {
    videoSelectedId = id;
    dispatch("hoverItem", { id, selected: videoSelectedId ? true : false });
  }
  function dispatchClickSelected() {
    if (videoSelectedId) dispatch("clickItem", { id: videoSelectedId });
    else console.info("No video selected");
  }

  function iframeFix(e: any) {
    const iframe: HTMLIFrameElement = e;
    try {
      iframe.contentWindow?.document.addEventListener("click", () => {
        dispatchClickSelected();
      });
    } catch (err) {
      console.warn("error adding click event to iframe", err);
    }
  }
</script>

<svelte:window on:resize={debounce(setSize, 200)} />

<!-- <div id="cssonly">
	{#if items && typeof items === "object"}
		{#each items as i (i.id)}
			<div class="player" on:mouseleave={(e) => selectItem()} on:mouseenter={(e) => selectItem(i.id)} id="select_{i.id}">
				{#if i.type === "iframe"}
					<iframe title={i.title} src={i.uri}></iframe>
				{/if}
			</div>
		{/each}
	{/if}
</div> -->
<div id="matrix">
  {#if items && typeof items === "object"}
    {#each drawItems as row (row.row)}
      <div class="row">
        {#each row.items as i (i.id)}
          <!-- svelte-ignore a11y_no_static_element_interactions -->
          <div
            class="col"
            style="padding-right:0px;padding-left:0px;--bs-gutter-x: 0px;"
            onmouseleave={(e) => hoverItem()}
            onmouseenter={(e) => hoverItem(i.id)}
            id="select_{i.id}"
          >
            {#if i.type === "iframe"}
              <iframe
                title={i.title}
                src={i.uri}
                onload={(e) => iframeFix(e.target)}
              ></iframe>
            {:else if i.type === "mediamtx-webrtc"}
              <hb-player-live media_type="whep" mediauri="{i.uri}/whep"
              ></hb-player-live>
            {:else if i.type === "mediamtx-webrtc-ptz"}
              <hb-player-live-camera-ptz
                media_type="whep"
                live_uri="{i.uri}/whep"
              ></hb-player-live-camera-ptz>
            {:else if i.type === "video"}
              <video controls>
                <source title={i.title} src={i.uri} type="video/mp4" />
                <track kind="captions" src="" srclang="en" label="English" />
                Your browser does not support the video tag.
              </video>
            {/if}
          </div>
        {/each}
      </div>
    {/each}
  {/if}
</div>

<style lang="scss">
  @forward "./styles/webcomponent.scss";
  @forward "./styles/bootstrap.scss";
</style>
